import React from 'react';
import BaseList from '@views/order-products/OrderProductsList';
import {ListViewProps} from '@src/components/_views/configurable/ListView';
import {IOrderProductModel} from '@src/@interfaces/models/Order/IOrderProductModel';

export default function OrderProductsList(props: Partial<ListViewProps<IOrderProductModel>>) {
    return <BaseList
            controllerName="OrderProducts"
            isIsolatedComponent
            {...props}
    />;
}
